import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsLoadingAPIRequest } from 'store/ApiClient';
import { PayPeriods, updatePayPeriodStatusRequest } from 'store/Collections/PayPeriods';
import { IStore } from 'store/types';
import { IPayPeriod, PayPeriodAction } from 'types';
import PayPeriodConfirmModal from './PayPeriodConfirmModal';

interface IReopenPayPeriodModalProps {
  siteId: string;
  orgId: string;
  payPeriod: IPayPeriod;
  onClose: () => void;
  dataCy?: string;
}

// Confirms before reopening a closed period. The saga toasts the outcome; the modal dismisses either way.
const ReopenPayPeriodModal = ({ siteId, orgId, payPeriod, onClose, dataCy = 'reopen-pay-period-modal' }: IReopenPayPeriodModalProps) => {
  const dispatch = useDispatch();
  const isReopening = useSelector((state: IStore) => selectIsLoadingAPIRequest(state, PayPeriods.UPDATE_PAY_PERIOD_STATUS_REQUEST));

  return (
    <PayPeriodConfirmModal
      title="Reopen Pay Period"
      message="Reopening this period unlocks payments and payee records for editing."
      confirmLabel="Reopen Pay Period"
      payPeriod={payPeriod}
      onConfirm={() => dispatch(updatePayPeriodStatusRequest({ siteId, orgId, payPeriod, status: PayPeriodAction.REOPEN, onComplete: onClose }))}
      onClose={onClose}
      isLoading={isReopening}
      dataCy={dataCy}
    />
  );
};

export default ReopenPayPeriodModal;
